import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types';
import Swal from "sweetalert2";
import { NavLink, useHistory } from "react-router-dom";
import { MenuItemCard, MenuItemCardVBE, MenuItemDiv, NavCard, TextDarkBlue } from "../../pages/Theme";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { ExpandLess } from "@material-ui/icons";
import { ExpandMore } from "@material-ui/icons";
import { makeStyles } from '@mui/styles';
import { styled, alpha } from "@mui/material/styles";
import { getUserNavigationConfrimPopup } from "../../redux/actions/commonAction";
import DropdownIcon from '../../common/images-new/dropdown-icon.svg'


const NavbarLink = ({ icon, title, url, numNotif, isVBE }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const vbeList = useSelector(state => state.auth.vbeLists);

    const userTheme = useSelector(state => state.auth.theme);
    const isDefaultTheme = useSelector(state => state.auth.isDefaultTheme);

    const useStyles = makeStyles((theme) => ({
        customMenu: {
            backgroundColor: isDefaultTheme == false && userTheme ? `${userTheme?.color3} !important` : 'white !important',
        },
    }));

    const [vbeLists, setvbeLists] = useState([]);
    const [anchorEl, setAnchorEl] = useState(false);
    const [width, setWidth] = useState(window.innerWidth)
    const open = Boolean(anchorEl);
    const popupRef = useRef();
    const [expandParent, setExpandParent] = useState(false);
    const [expandMenu, setexpandMenu] = useState(false);
    const [listVbe, setListVbe] = useState([]);
    const [index, setIndex] = useState(null);
    const reflectionFeedbackProcessing = useSelector((state) => state.reflectionFeedbackReducer.reflectionFeedbackProcessing || false);
    const navigatingConfrimPopup = useSelector((state) => state.commonData.userNavigatingConfrimPopup);
    const handleClick = (event) => {
        if (navigatingConfrimPopup) {
            Swal.fire({
                heightAuto: false,
                title: "Changes not saved",
                text: "Are you sure to leave this page?",
                icon: "warning",
                showCancelButton: false,
                showDenyButton: true,
                confirmButtonText: "Confirm",
                denyButtonText: "Cancel",
                confirmButtonColor: "#3085d6",
                denyButtonColor: "#c1c1c1",
            }).then((result) => {
                if (result.isConfirmed) {
                    setAnchorEl(event.currentTarget);
                    dispatch(getUserNavigationConfrimPopup(false));
                }
            });
        }
        else {
            setAnchorEl(event.currentTarget);
        }
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    useEffect(() => {
        const handleMobileWidth = () => {
            if (window.innerWidth) {
                setWidth(window?.innerWidth);
            }
        }
        window.addEventListener('resize', handleMobileWidth);
        return () => {
            window.removeEventListener('resize', handleMobileWidth);
        }
    }, [])

    useEffect(() => {
        let data = [];
        if (vbeList?.Vbe_list != "" && vbeList?.Vbe_list != undefined && vbeList?.Vbe_list != null) {
            {
                Object.entries(vbeList?.Vbe_list)?.map((key, index) => {
                    key?.map((keys, ind) => {
                        if (typeof keys === 'string') {
                            let response = {
                                subTitle: true,
                                title: keys
                            }
                            data.push(response)
                        }
                        if (Array.isArray(keys)) {
                            {
                                keys?.map((i, idx) => {
                                    let response = {
                                        subTitle: false,
                                        title: i?.moduleName,
                                        path: i?.modulePath,
                                    }
                                    data.push(response)
                                })
                            }
                        }
                    })
                })
            }
            setvbeLists(data)
        }
    }, []);

    useEffect(() => {
        if (index === null) {
            vbeList?.message?.forEach((value) => { value["isexpand"] = expandMenu; return value });
            setListVbe(vbeList?.message);
        }
    }, [])


    function isChange(id) {
        if (id !== null) {
            listVbe[parseInt(id)].isexpand = !listVbe[parseInt(id)].isexpand;
            setListVbe(listVbe);
        }
    }

    const handleMenu = () => {
        handleClose();
    }
    useEffect(() => { }, [navigatingConfrimPopup]);
    const handleNavigation = (url) => {
        if (navigatingConfrimPopup) {
            Swal.fire({
                heightAuto: false,
                title: "Changes not saved",
                text: "Are you sure you want to leave this page?",
                icon: "warning",
                showCancelButton: false,
                showDenyButton: true,
                confirmButtonText: "Confirm",
                denyButtonText: "Cancel",
                confirmButtonColor: "#3085d6",
                denyButtonColor: "#c1c1c1",
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(getUserNavigationConfrimPopup(false));
                    history.push(url);
                }
            });
        }
        else {
            history.push(url);
        }
    }
    // useEffect(() => {
    //     const handleClickVBE = (e) => {
    //         if (!popupRef?.current?.contains(e.target)) {
    //            handleClose();
    //         }
    //     }

    //     document.addEventListener('mousedown', handleClickVBE, false);

    //     return function cleanup() {
    //         document.removeEventListener('mousedown', handleClickVBE, false);
    //     };
    // });

    const classes = useStyles();
    return (<>
        {isVBE == false &&
            <NavLink activeClassName="is-active" to={url}
                className={`flex items-center xl:mr-5 lg:mr-0 mr-2 mb-3 lg:mb-0 hover:opacity-80 nav-navigate ${!reflectionFeedbackProcessing ? 'cursor-pointer' : 'cursordisabled'}`}
                onClick={(e) => {
                    e.preventDefault();
                    handleNavigation(url);
                }}
            >
                <div className={"flex relative " + (numNotif > 0 ? "mr-3" : "mr-2")}>
                    <img src={icon} alt="icon"></img>
                    {
                        numNotif > 0 &&
                        <div className="bg-red-500 rounded-full w-4 h-4 flex justify-center items-center absolute -top-2 -right-2">
                            <p className="text-xs text-white text-center">{numNotif}</p>
                        </div>
                    }
                </div>

                <p className="font-normal lg:text-white text-sm sm:mr-2 lg:mr-1 lg:mr-2 hover:underline">{title}</p>
            </NavLink>}
        {isVBE == true &&
            <div>
                <div aria-controls={open ? 'basic-menu' : undefined} className={`${!reflectionFeedbackProcessing ? 'cursor-pointer' : 'cursordisabled'}`}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined} id="basic-button" onClick={width < 1024 ? () => {
                        if (navigatingConfrimPopup) {
                            Swal.fire({
                                heightAuto: false,
                                title: "Changes not saved",
                                text: "Are you sure to leave this page?",
                                icon: "warning",
                                showCancelButton: false,
                                showDenyButton: true,
                                confirmButtonText: "Confirm",
                                denyButtonText: "Cancel",
                                confirmButtonColor: "#3085d6",
                                denyButtonColor: "#c1c1c1",
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    dispatch(getUserNavigationConfrimPopup(false));
                                }
                            });
                        }
                        else {
                            setExpandParent(!expandParent);
                        }
                    } : handleClick}>
                    <div className={"flex relative " + (numNotif > 0 ? "mr-3" : "mr-2")}>
                        <img src={icon} className="nav-icon mr-2" alt="icon"></img>
                        <p className={width < 1024 ? `font-normal navbar-color mx-2 hover:underline` : `font-normal lg:text-white text-sm lg:mr-2 hover:underline`}>
                            {title}
                        </p>
                        {width < 1024 && (expandParent ? <ExpandLess className="nav-icon navbar-color" />
                            : <ExpandMore className="nav-icon navbar-color" />)}
                    </div>
                </div>
                {width > 1024 ?
                    <MenuItemCard>
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                            classes={{ paper: classes.customMenu }}
                        >
                            <MenuItemCard>
                                {vbeList?.message?.map((r) => {
                                    return (<>
                                        <MenuItem className={"subTitleStyle cursor-auto text-black"}><p className="cursor-auto">{r.menu_name}</p></MenuItem>
                                        {r.sub_menus?.map((s, ind) => {
                                            return (
                                                <MenuItem
                                                    className={s.menu_url ? "" : "cursor-auto"}
                                                    onClick={(s.menu_url) ? () => {
                                                        handleMenu(s.menu_url);
                                                        window.open(s.menu_url, '_blank')
                                                    } : () => { }}
                                                >

                                                    {s.menu_url ? <p className="path-navigate" ><MenuItemDiv>{s.menu_name}</MenuItemDiv></p> : <p className="cursor-auto"><MenuItemDiv>{s.menu_name}</MenuItemDiv></p>}
                                                </MenuItem>
                                            )
                                        })
                                        }
                                    </>)
                                })}
                            </MenuItemCard>
                        </Menu>
                    </MenuItemCard>
                    // open && (
                    //     <div ref={popupRef}>
                    //     <MenuItemCard className="absolute -top-4 right-20 mt-4 p-3 rounded-md filter drop-shadow transform z-10 translate-y-10"
                    //     >
                    //         <li className="space-y-2">
                    //             {vbeList?.message?.map((r) => {
                    //                 return (<>
                    //                     <MenuItem className={"subTitleStyle cursor-auto text-black"}><p className="cursor-auto">{r.menu_name}</p></MenuItem>
                    //                     {r.sub_menus?.map((s, ind) => {
                    //                         return (
                    //                             <MenuItem
                    //                                 className={s.menu_url ? "" : "cursor-auto"}
                    //                                 onClick={(s.menu_url) ? () => { handleMenu(s.menu_url); window.open(s.menu_url, '_blank') } : () => { }}
                    //                             >

                    //                                 {s.menu_url ? <p className="path-navigate" ><MenuItemDiv>{s.menu_name}</MenuItemDiv></p> : <p className="cursor-auto"><MenuItemDiv>{s.menu_name}</MenuItemDiv></p>}
                    //                             </MenuItem>
                    //                         )
                    //                     })
                    //                     }
                    //                 </>)
                    //             })}
                    //         </li>
                    //     </MenuItemCard>
                    //     </div>
                    // )
                    :
                    <div className="mx-9" id="basic-button" style={{ display: !expandParent && "none" }}>

                        {listVbe?.map((r, inx) => (
                            <>
                                <div className="flex mr-12 mt-4 gap-2 cursor-pointer" key={inx} id={inx} onClick={(e) => { isChange(e.target.id); setexpandMenu(!expandMenu) }}>
                                    <p className="font-normal navbar-color cursor-pointer hover:opacity-80" id={inx}>
                                        {r.menu_name}
                                    </p>
                                    {r.isexpand ? <ExpandLess className="nav-icon  cursor-pointer navbar-color" /> :
                                        <ExpandMore className="nav-icon  cursor-pointer navbar-color" />}
                                    {/* <img src={icon} className="nav-icon mr-2" alt="icon"></img> */}
                                </div>

                                <div style={{ display: !r.isexpand && "none" }}>
                                    {r.sub_menus?.map((s, ind) => (
                                        <div className="flex mt-4 mx-2" key={ind} >
                                            {s.menu_url ? <a className="font-normal navbar-color" href={s.menu_url} target="_blank">
                                                {s.menu_name}
                                            </a> :
                                                <p className="font-normal navbar-color ">
                                                    {s.menu_name}
                                                </p>
                                            }
                                            {/* <img src={icon} className="nav-icon mr-2" alt="icon"></img> */}
                                        </div>))}
                                </div>
                            </>
                        ))}
                    </div>
                }
            </div >
        }
    </>)
}

NavbarLink.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
}

export default NavbarLink